import React, { useState, useEffect, useRef } from 'react';
import styles from './CustomDropdown.module.scss';
import cn from 'classnames';

const CustomDropdown = ({ options, selected, onChange, placeholder, variant = 'session', style,position="end", helperText="", ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const variantClass = variant === 'calendar' ? styles.calendarVariant : styles.sessionVariant;

  return (
    <div className={cn(styles.dropdown, props.className)} ref={dropdownRef} {...props}>
      {/* {helperText && <p className={styles.helperText}>{helperText}</p>} */}
      <div
        className={cn(styles.dropdownInput, variantClass,styles.variantClass)}
        onClick={() => setIsOpen(!isOpen)}
        style={style}
      >
        <span 
          className={selected ? styles.selected : styles.placeholder}
          data-custom-placeholder={!selected ? "true" : "false"}
        >
          {selected ? selected.label : placeholder}
        </span>
        {position === 'end' && <span className={`${styles.chevron} ${isOpen ? styles.open : ''}`}> </span>}
        {position === 'start' && <span className={`${styles.chevron2} ${isOpen ? styles.open : ''}`}> </span>}
      </div>


      {isOpen && (
        <ul className={styles.dropdownList}>
          {options.map((option, idx) => (
            <li
              key={option.value !== undefined ? option.value : idx}
              className={styles.dropdownItem}
              onClick={() => handleSelect(option.value !== undefined ? option : { label: option, value: idx })}
            >
              {option.label !== undefined ? option.label : option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown; 